import {ParamTypes, useTypedURLSearchParam} from '../useTypedURLSearchParam'

export function useSampleIdSearchParam() {
  const [sampleId, setSampleId] = useTypedURLSearchParam('sampleId', ParamTypes.string)
  return {
    sampleId,
    setSampleId
  }
}
